import { createGlobalStyle } from 'styled-components';

export default createGlobalStyle`
  
    @font-face {
        font-family: 'PannoTextLight';
        src: url('/assets/fonts/PannoTextLight.eot');
        src: url('/assets/fonts/PannoTextLight.eot') format('embedded-opentype'),
            url('/assets/fonts/PannoTextLight.woff2') format('woff2'),
            url('/assets/fonts/PannoTextLight.woff') format('woff'),
            url('/assets/fonts/PannoTextLight.ttf') format('truetype'),
            url('/assets/fonts/PannoTextLight.svg#PannoTextLight') format('svg');
        font-weight: normal;
        font-style: normal;
    }

    @font-face {
        font-family: 'PannoTextNormal';
        src: url('/assets/fonts/PannoTextNormal.eot');
        src: url('/assets/fonts/PannoTextNormal.eot') format('embedded-opentype'),
            url('/assets/fonts/PannoTextNormal.woff2') format('woff2'),
            url('/assets/fonts/PannoTextNormal.woff') format('woff'),
            url('/assets/fonts/PannoTextNormal.ttf') format('truetype'),
            url('/assets/fonts/PannoTextNormal.svg#PannoTextNormal') format('svg');
        font-weight: normal;
        font-style: normal;
    }

    @font-face {
        font-family: 'PannoTextMedium';
        src: url('/assets/fonts/PannoTextMedium.eot');
        src: url('/assets/fonts/PannoTextMedium.eot') format('embedded-opentype'),
            url('/assets/fonts/PannoTextMedium.woff2') format('woff2'),
            url('/assets/fonts/PannoTextMedium.woff') format('woff'),
            url('/assets/fonts/PannoTextMedium.ttf') format('truetype'),
            url('/assets/fonts/PannoTextMedium.svg#PannoTextMedium') format('svg');
        font-weight: normal;
        font-style: normal;
    }

    @font-face {
        font-family: 'PannoTextSemiBold';
        src: url('/assets/fonts/PannoTextSemiBold.eot');
        src: url('/assets/fonts/PannoTextSemiBold.eot') format('embedded-opentype'),
            url('/assets/fonts/PannoTextSemiBold.woff2') format('woff2'),
            url('/assets/fonts/PannoTextSemiBold.woff') format('woff'),
            url('/assets/fonts/PannoTextSemiBold.ttf') format('truetype'),
            url('/assets/fonts/PannoTextSemiBold.svg#PannoTextSemiBold') format('svg');
        font-weight: normal;
        font-style: normal;
    }

    @font-face {
        font-family: 'PannoTextBold';
        src: url('/assets/fonts/PannoTextBold.eot');
        src: url('/assets/fonts/PannoTextBold.eot') format('embedded-opentype'),
            url('/assets/fonts/PannoTextBold.woff2') format('woff2'),
            url('/assets/fonts/PannoTextBold.woff') format('woff'),
            url('/assets/fonts/PannoTextBold.ttf') format('truetype'),
            url('/assets/fonts/PannoTextBold.svg#PannoTextBold') format('svg');
        font-weight: normal;
        font-style: normal;
    }


    *{
        box-sizing:border-box;
    }
    
    html{
        /* overflow:hidden; */
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        font-family: 'Arial', sans-serif;
    }

    body {
        background:white;
        margin: 0;
        /* overflow:hidden; */
    }
    
    body.blue{
    }
    
    a,button{
        -webkit-tap-highlight-color: rgba(0,0,0,0);
    }

    .slider-button {
        border:0px;
        background: rgba(0, 0, 0, 0.4);
        color: white;
        padding: 10px;
        outline: 0px;
        opacity: 1;
        cursor: pointer;
    }

    .slider-list {
        min-height: 270px;
    }

    .info-block {
        line-height: 1.3 !important;
        max-width: 55rem;
        margin-bottom: 3.5rem;
        text-align: justify;
    }

    .info-block hr {
        margin: 3.5rem auto;
    }

    .info-block {
        h2 {
            text-transform: uppercase;
        }

        .flex {
            display: flex !important;
        }

        .flex .full {
            max-width: 90%;
        }

        .flex .half {
            max-width: 45%;
        }

        .flex-align-center {
            align-items: center;
        }

        .flex-justify-space-around {
            justify-content: space-around;
        }

        .list-title {
            font-weight: 600;
            text-transform: uppercase;
            margin-bottom: 8px;
            font-size: 1.15rem;
        }

        .lead-text {
            font-style: italic;
            color: rgba(20, 67, 133, 1) !important;
            margin-bottom: 0 !important;
            font-size: 1.1rem;            
        }

        .lead-text:last-of-type {
            margin-bottom: 8px !important;
        }

        ol > li,
        ul > li {
            font-size: 1.1rem;
            margin-bottom: 10px !important;
            padding-left: .5rem;   
        }

        ol > li::marker {
            font-weight: 600;
        }

        li > ul > li {
            line-height: 1.3 !important;
            margin-bottom: 5px !important;
        }

        ul {
            list-style-type: disc;
          }

        .plus-minus-list {
            list-style: none;
        }

            .plus-minus-list li {
                position: relative;
                /* text-indent: -1rem; */
            }

            .plus-minus-list li.plus::before {
                content: "\uff0b";
                position: absolute;
                left: -1rem;
                font-weight: 900;
            }

            .plus-minus-list li.minus::before {
                content: "\u2212";
                position: absolute;
                left: -1rem;
                font-weight: 900;
            }

        .green {
            color: rgba(78, 118, 65, 1) !important;
        }

        .red {
            color: rgba(188, 53, 16, 1) !important;
        }
    }
`;
